import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import React, { ChangeEvent, FormEvent, useCallback, useState } from 'react'
import { Button, Col, Container, Form, Row, Spinner } from 'react-bootstrap'
import OrderService from '../../services/order-service';
import { OrderHistories } from '../../types';
import { capitalizeWords } from '../../helper/utils';
import { mapStatusToColor } from '../../data/map-file';

const TrackOrder = () => {

    const [searchValue, setSearchValue] = useState<string>("");
    const [trackedData, setTrackedData] = useState<OrderHistories[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleSearch = useCallback(async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        e.stopPropagation();

        if (!searchValue) {
            return ;
        }

        setIsLoading(true);

        const response = await OrderService.trackOrder(searchValue);

        setTrackedData(response);
        setIsLoading(false);

    }, [searchValue]);

    return (
        <Container>
            <h4 style={{ fontSize: '1.4rem' }}>Track your Order</h4>
            <p style={{fontSize: '.9rem'}} className='mb-4'><small>You can track order by supplying your [ORD-25041837528] number in the search field and press enter.</small></p>
            <Row>
                <Col xs={12} md={7}>
                    <Form noValidate onSubmit={handleSearch}>
                        <Form.Group className='position-relative'>
                            <Form.Control 
                                type='text' 
                                name='orderNumber' 
                                placeholder='Search using order number'
                                style={{
                                    borderRadius: '200px'
                                }}
                                onChange={(e: ChangeEvent<HTMLInputElement>) => setSearchValue(e.target.value)}
                            />
                            <Button 
                                type='submit'
                                className='d-flex flex-column justify-content-center align-items-center'
                                style={{
                                    borderRadius: '200px',
                                    width: '29px',
                                    height: '29px',
                                    background: '#bbbbbb',
                                    border: '#bbbbbb',
                                    position: 'absolute',
                                    top: '5px',
                                    right: '6px'
                                }}
                            ><MagnifyingGlassIcon width={16} height={16} /></Button>
                        </Form.Group>
                    </Form>
                </Col>
            </Row>
            <Row className='my-5'>
                <Col xs={12} md={7}>
                    {(() => {
                        if (isLoading) return <Spinner animation='border' /> ;
                        else if (!isLoading && trackedData.length === 0) return (
                            <Container as='div' style={{ fontSize: '.9rem' }}>
                                No order history at the moment.
                            </Container>
                        )
                        else {
                            return trackedData.map((track: OrderHistories, i:number) => {
                                return (
                                    <Container as='article' className='mb-5 d-flex justify-content-between align-items-center position-relative'>
                                        <span className={`bg-${mapStatusToColor[track.status]} dot-pointer`}></span>
                                        
                                        {
                                            (i+1) !== trackedData.length && (
                                                <span className={`pointer-line`} style={{
                                                    borderRight: `1px dashed #dee2e6`
                                                }}></span>
                                            )
                                        }

                                        <h5 style={{ fontSize: '.9rem', fontWeight: 600, marginBottom: 0, textIndent: 10 }}>{track.comment}</h5>
                                        <span 
                                            style={{ fontSize: '.8rem' }} 
                                            className={`text-white bg-${mapStatusToColor[track.status]} p-1 px-2 rounded`}
                                        >{capitalizeWords(track.status.toLowerCase())}</span>
                                    </Container>
                                )
                            })
                        }
                    })()}
                </Col>
            </Row>
        </Container>    
    )
}

export default TrackOrder
